module.exports = __webpack_public_path__ + "static/img/blog_sm_landscape.8d98c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/blog_sm_landscape.png
// module id = rxw0
// module chunks = 1